import gql from "graphql-tag";

export const CREATE_AGE_BRACKET = gql`
  mutation AddAgeBracket($data: AgeBracketDataInput) {
    addAgeBracket(data: $data) {
      id
      name
      minAge
      maxAge
      order
    }
  }
`;

export const UPDATE_AGE_BRACKET = gql`
  mutation UpdateAgeBracket($where: AgeBracketWhereInput, $data: AgeBracketDataInput) {
    updateAgeBracket(where: $where, data: $data) {
      id
      name
      minAge
      maxAge
      order
    }
  }
`;

export const DELETE_AGE_BRACKET = gql`
  mutation DeleteAgeBracket($where: AgeBracketWhereInput) {
    deleteAgeBracket(where: $where) {
      id
    }
  }
`;

const ageBrackets = { CREATE_AGE_BRACKET, UPDATE_AGE_BRACKET, DELETE_AGE_BRACKET };

export default ageBrackets;
